import React from 'react';
import { Link } from "react-router-dom";
import './Home.css';
import './Details.css';

function Hint() {
  return (
    <div className = "grid-container">
      <div className="grid-item back">
        <Link to="/CE" className="purple back">Back</Link>
      </div>

      <div className = "Hint">
          <h1>")</h1>       
      </div>
    </div>
    
  )
}
export default Hint;